<template>
  <div>
    <div v-if="loginUser">
      <div v-if="loginUser.id===1">
        <div>
          撰写：
          <router-link :to="{path:'/edit/post'}" class="am-margin-right-xs">撰写文章</router-link>
          <router-link :to="{path:'/edit/page'}" class="am-margin-right-xs">创建页面</router-link>
        </div>
        <div class="am-margin-top-xs">
          管理：
          <router-link :to="{path:'/edit/posts'}" class="am-margin-right-xs">文章</router-link>
          <router-link :to="{path:'/edit/pages'}" class="am-margin-right-xs">独立页面</router-link>
          <router-link :to="{path:'/edit/comments'}" class="am-margin-right-xs">评论</router-link>
          <router-link :to="{path:'/edit/type'}" class="am-margin-right-xs">分类</router-link>
          <router-link :to="{path:'/edit/tag'}" class="am-margin-right-xs">标签</router-link>
          <router-link :to="{path:'/edit/users'}" class="am-margin-right-xs">用户</router-link>
        </div>
        <div class="am-margin-top-xs">
          设置：
          <router-link :to="{path:'/edit/option'}" class="am-margin-right-xs">基本设置</router-link>
        </div>
      </div>
      <div class="am-panel am-panel-default am-round am-margin-top" v-else>
        <div class="am-panel-bd am-text-center">
          无访问权限
        </div>
      </div>
    </div>
    <div class="am-panel am-panel-default am-round am-margin-top" v-else>
      <div class="am-panel-bd am-text-center">
        请先
        <router-link :to="{path:'/login'}">登录</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Edit',
  mounted () {
    document.title = '控制台'
  },
  computed: {
    ...mapGetters([ 'loginUser' ]),
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Edit.vue